module.exports = __webpack_public_path__ + "img/hero-image-landing.8884a809.png";